import { reducers } from 'redux/core'
import actions from 'redux/actions'
import request from 'sb-request'
import { modifyItems as modifyQueueItems } from 'redux/models/queue/actions'

import { constants, links, getGqlQuery } from 'common/helpers'


const fetch = () => (
  request.post('graphql?name=unsubscribe', {
    body: {
      query: `{
        unsubscribeReasons(quickFlow: true) {
          value: name
          message: reason
        }
        queue(limit: 12) {
          items {
            year
            month
            status: statusName
            tracking {
              id
              trackingNumber
              trackingUrl
              shipmentDate
              status
            }
            products {
              id
              name
              brand
              image
              index
              upchargePrice
              isLimitedEdition
            }
          }
        }
      }`,
    },
    modifyResult: ({ queue, unsubscribeReasons }) => {
      const { items: queueItems } = modifyQueueItems(queue)

      return {
        queueItems,
        unsubscribeReasons: unsubscribeReasons || [],
        hasError: !queueItems.length || !unsubscribeReasons.length,
      }
    },
  })
    .then(({ queueItems, unsubscribeReasons, hasError }) => {
      reducers.view.cancelSubscriptionPage.update({ queueItems, unsubscribeReasons, hasError, isFetched: true })
    })
)

const setActiveStep = (activeStep) => {
  reducers.view.cancelSubscriptionPage.update({
    activeStep,
  })
}

const selectReason = ({ activeReason, activeStep }) => {
  reducers.view.cancelSubscriptionPage.update({ activeReason, activeStep })
}

const setRefund = ({ refund, activeStep }) => {
  reducers.view.cancelSubscriptionPage.update({ refund, activeStep })
}

const resubscribe = () =>
  actions.models.subscription.resubscribe({
    popup: constants.analyticsEvents.resubscribePopup.postCancel,
  })
    .then(({ premiumProduct }) => {
      if (premiumProduct) {
        actions.models.modals.open(constants.modals.premiumProducts.WelcomeBack, {
          item: premiumProduct,
        })
      }
      else {
        actions.models.modals.open(constants.modals.resubscribe.ResubscribeSuccess)
      }

      actions.models.router.replace(links.profile.ordersStatus)
    }, () => {})

const setOfferAcceptedForUser = () => {
  // we need this to prevent showing offers more then 1 time (in both cancel flows)
  // use this name because it's used in old flow offer (modals.cancelSubscription.ProlongOffer)
  actions.models.ui.setClosedPopup('prolongOfferModal')
}

const updateFeedbackStatus = ({ isFeedbackSent, isUnsubscribeSelected }) =>
  reducers.view.cancelSubscriptionPage.update({ isFeedbackSent, isUnsubscribeSelected })

const sendFeedback = ({ message, reason, isUnsubscribeSelected }) => {
  actions.models.ui.showRequestLoader()

  const feedbackQuery = getGqlQuery('unsubscribeFeedback', {
    input: {
      message,
      reason,
      unsubscribeChoice: isUnsubscribeSelected,
    },
  })

  return request.post('graphql?name=unsubscribeFeedback', {
    withErrorModal: false,
    body: {
      query: `
        mutation {
          ${feedbackQuery} {
            result
          }
        }
      `,
    },
  })
    .finally(() => actions.models.ui.hideRequestLoader())
}


export default {
  fetch,
  setActiveStep,
  selectReason,
  setRefund,
  resubscribe,
  setOfferAcceptedForUser,
  updateFeedbackStatus,
  sendFeedback,
}
